import Subscriber from '@core/tracking/Subscriber';

export default class GTMHandler implements Subscriber {

    public notify(data: Object): void {
        self.dataLayer.push(data);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/tracking/gtm/GTMHandler.ts